exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-67924125]{opacity:.75}.collpase-transition.is-active[data-v-67924125]{display:block}.collpase-transition[data-v-67924125]{display:none}", ""]);

// exports
